<template>
  <FormElement :horizontal="true" :style="{ 'max-width': '700px', margin: '0 auto' }">
    <fieldset class="k-form-fieldset">
      <div v-if="kendoForm.visited &&
        kendoForm.errors &&
        kendoForm.errors.VALIDATION_SUMMARY" class="k-messagebox k-messagebox-error">
        {{ kendoForm.errors.VALIDATION_SUMMARY }}
      </div>

      <Field :name="'user_id'" :type="'text'" label="label" :component="'SupplierForm'" :validator="requiredValidator"
        v-if="isShowAutoComplete">
        <template v-slot:SupplierForm="{ }">
          <div class="k-form-field">
            <label class="k-label">{{ getMessageByLang('user', 'Пользователь') }}</label>
            <div v-if="isShowAutoComplete && Array.isArray(filteredUsers)" class="k-form-field-wrap">
              <AutoComplete :data-items="completeDataItems" :text-field="'name'" :data-item-key="'id'"
                :placeholder="getUserPlaceHolder" @change="handleChangeUser" @filterchange="handleFilterChange" />
            </div>
          </div>
        </template>
      </Field>

      <Field :name="'name'" :type="'text'" :component="'SupplierForm'" :label="supplierNameMessage"
        :validator="nameValidator">
        <template v-slot:SupplierForm="{ props }">
          <FormInput v-bind="props" @change="props.onChange" @blur="props.onBlur" @focus="props.onFocus" />
        </template>
      </Field>

      <Field :name="'contact_info'" :type="'text'" :component="'SupplierForm'"
        :label="supplierContactInformationMessage" :validator="requiredValidator">
        <template v-slot:SupplierForm="{ props }">
          <FormTextArea v-bind="props" @change="props.onChange" @blur="props.onBlur" @focus="props.onFocus">
          </FormTextArea>
        </template>
      </Field>

      <Field :name="'status'" :type="'text'" :component="'SupplierForm'"
        :validator="requiredValidator">
        <template v-slot:SupplierForm="{ props }">
          <div class="k-form-field">
            <label class="k-label">{{ statusMessage }}</label>
            <div class="k-form-field-wrap">
              <DropDownList v-bind="props" @blur="props.onBlur" @focus="props.onFocus" :data-items="statuses"
              :text-field="'name'" :data-item-key="'id'" :value-field="'id'" :value-primitive="true" v-model="status" />
            </div>
          </div>
        </template>
      </Field>

      <Field :name="'tax_number'" :type="'text'" :component="'SupplierForm'" label="ИНН"
        :validator="innValidator">
        <template v-slot:SupplierForm="{ props }">
          <FormInput v-bind="props" @change="props.onChange" @blur="props.onBlur" @focus="props.onFocus" />
        </template>
      </Field>

      <Field :name="'legal_address'" :type="'text'" :component="'SupplierForm'" label="Юридический адрес компании">
        <template v-slot:SupplierForm="{ props }">
          <FormInput v-bind="props" @change="props.onChange" @blur="props.onBlur" @focus="props.onFocus" />
        </template>
      </Field>

      <Field :name="'email'" :type="'text'" :component="'SupplierForm'" label="Email"
        :validator="emailValidator">
        <template v-slot:SupplierForm="{ props }">
          <FormInput v-bind="props" @change="props.onChange" @blur="props.onBlur" @focus="props.onFocus" />
        </template>
      </Field>

      <field
        :id="'phoneNumber'"
        :name="'phoneNumber'"
        :label="phoneNumberMessage"
        :mask="'(+7) 000-000-00-00'"
        :component="'SupplierForm'"
      >
        <template v-slot:myTemplate="{ props }">
          <formmaskedtextbox
            v-bind="props"
            @change="props.onChange"
            @blur="props.onBlur"
            @focus="props.onFocus"
          ></formmaskedtextbox>
        </template>
      </field>

      <Field :name="'website'" :type="'text'" :component="'SupplierForm'" label="Ссылка на официальный сайт">
        <template v-slot:SupplierForm="{ props }">
          <FormInput v-bind="props" @change="props.onChange" @blur="props.onBlur" @focus="props.onFocus" />
        </template>
      </Field>

      <Field :name="'contact_person'" :type="'text'" :component="'SupplierForm'" label="ФИО ответственного лица">
        <template v-slot:SupplierForm="{ props }">
          <FormInput v-bind="props" @change="props.onChange" @blur="props.onBlur" @focus="props.onFocus" />
        </template>
      </Field>
    </fieldset>
  </FormElement>
</template>
<script>
import { Field, FormElement } from "@progress/kendo-vue-form";
import { DropDownList } from '@progress/kendo-vue-dropdowns';
import FormInput from "../ProfileComponents/FormInput.vue";
import FormTextArea from "../ProfileComponents/FormTextArea.vue";
import { provideLocalizationService } from "@progress/kendo-vue-intl";
import axios from "axios";
import { AutoComplete } from "@progress/kendo-vue-dropdowns";
import { getMessageByLang } from '@/utils/translate.js';

import {
  requiredValidator,
  firstNameValidator,
  emailValidator,
  phoneValidator,
  innValidator
} from "../../assets/validators";
export default {
  components: {
    Field,
    FormElement,
    FormInput,
    FormTextArea,
    DropDownList,
    AutoComplete
  },
  inject: {
    kendoForm: { default: {} },
    kendoLocalizationService: { default: null },
  },
  props: {
    supplierItem: {
      type: Object,
      required: false,
      default: null
    },
    onUpdateUserId: {
      type: Function,
      required: false,
      default: null
    },
    propType: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      phoneValidator: phoneValidator,
      emailValidator: emailValidator,
      getMessageByLang: getMessageByLang,
      nameValidator: firstNameValidator,
      requiredValidator: requiredValidator,
      innValidator: innValidator,
      users: [],
      user_id: {},
      statuses: [
        { id: 'active', name: this.getStatusText('statusActive') },
        { id: 'inactive', name: this.getStatusText('statusUnactive') },
        { id: 'suspended', name: this.getStatusText('statusActiveStop') }
      ],
      status: {},
      filteredUsers: [],
      isShowAutoComplete: false,
      foo: ''
    };
  },
  computed: {
    getUserPlaceHolder() {
      if (this.user_id) {
        return this.foo;
      }

      return this.getMessageByLang('selectUserText', 'Выберите пользователя');
    },

    completeDataItems() {
      return this.filteredUsers;
    },

    supplierNameMessage() {
      return provideLocalizationService(this).toLanguageString(
        "supplierName",
        "Supplier Name"
      );
    },
    supplierContactInformationMessage() {
      return provideLocalizationService(this).toLanguageString(
        "supplierContactInformation",
        "Supplier Contact Information"
      );
    },
    statusMessage() {
      return provideLocalizationService(this).toLanguageString(
        "status",
        "Status"
      );
    },
    cancelMessage() {
      return provideLocalizationService(this).toLanguageString(
        "cancel",
        "Cancel"
      );
    },
    loginMessage() {
      return provideLocalizationService(this).toLanguageString(
        "login",
        "Login"
      );
    },
  },
  methods: {
    getStatusText(status) {
      return provideLocalizationService(this).toLanguageString(
        status,
        status
      );
    },

    handleFilterChange(event) {
      try {
        this.foo = event.filter.value;

        if (event && event.filter && event.filter.value) {
          const filter = event.filter.value.toLowerCase();
          this.filteredUsers = this.users.filter(user =>
            user.name.toLowerCase().includes(filter)
          );
        }

      } catch (err) {
        console.error(err);
      }
    },
    handleChangeUser(userItem) {
      const val = userItem?.item?.id || null
      if (val) {
        this.user_id = val;
        if (this.onUpdateUserId) {
          this.onUpdateUserId(this.propType, this.user_id);
        }

      } else {
        if (userItem.value) {
          const filter = userItem.value || '';
          if (filter.trim() === '') {
            this.filteredUsers = JSON.parse(JSON.stringify(this.users));
          } else {
            this.filteredUsers = this.users.filter(user =>
              user.name.toLowerCase().includes(filter.toLowerCase())
            );
          }
        }
      }
    },
    clear() {
      this.kendoForm.onFormReset();
    },
  },
  mounted() {
    var self = this;
    axios.get('/api/v1/users/select')
      .then(res => {
        try {
          if (res.data) {
            self.users = res.data.data;
            this.filteredUsers = JSON.parse(JSON.stringify(res.data.data));

            if (this.supplierItem) {
              const savedUser = this.filteredUsers.filter((user) => {
                if (user.id === this.supplierItem?.user?.id) return user;
              })

              if (Array.isArray(savedUser) && savedUser.length > 0) {
                this.foo = savedUser[0].name;
                this.user_id = savedUser[0].id;
              }
            }

            this.isShowAutoComplete = true;
          }

        } catch (err) {
          console.error(err);
        }
      })
      .catch(function (error) {
        console.error(error);

        if (error.response) {
          if (error.response.data.message) {
            this.getMessageByLang('error', "Ошибка")
          }
        } else if (error.request) {
          console.log(error.request);
          this.getMessageByLang('error', "Ошибка")
          
        }
      });
  }
};
</script>
<style scoped>
.k-form-buttons {
  justify-content: center;
}
</style>